var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ee-card-buttons"},[_c('r-button',{attrs:{"simple":""},on:{"click":_vm.cancel}},[_vm._v(" Отменить ")]),_c('r-button',{attrs:{"type":"primary","disabled":_vm.disabled},on:{"click":_vm.save}},[_vm._v(" Применить ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }